import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'jquery'
import animate from 'animate.css'


import Axios from 'axios'
Axios.interceptors.response.use(function (response) {
  return response
},function (error) {
  // if(error.response.status === 403){
  //   ElementUI.Notification.error({
  //     title:'无权访问',
  //     message:'您无权访问该资源!'
  //   });
  //   return error;
  // }else {
    // ElementUI.Notification.error({
    //   title:'请求错误',
    //   message:'Network Error'
    // });
    return error;
  // }
});

Vue.use(animate)
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)
Vue.config.productionTip = false
Vue.prototype.addImgClass = function() {
  this.$nextTick(() => {
    const imgs = this.$el.querySelectorAll('img')
    imgs.forEach((img) => {
      img.classList.add('html-img')
    })
  })
}

// import Viewer from 'v-viewer' //图片查看插件
// import 'viewerjs/dist/viewer.css'
// Vue.use(Viewer)// 图片预览
 
// Viewer.setDefaults({
//  defaultOptions: {
//     zIndex: 9999
//   },
//   Options: {
//     "inline": true,
//     "button": true,
//     "navbar": true,
//     "title": true,
//     "toolbar": true,
//     "tooltip": true,
//     "movable": true,
//     "zoomable": true,
//     "rotatable": true,
//     "scalable": true,
//     "transition": true,
//     "fullscreen": true,
//     "keyboard": true,
//     "url": "data-source"
//   }
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js